import { render, staticRenderFns } from "./firstDrops.vue?vue&type=template&id=a57c47f6&scoped=true"
import script from "./firstDrops.vue?vue&type=script&lang=js"
export * from "./firstDrops.vue?vue&type=script&lang=js"
import style0 from "./firstDrops.vue?vue&type=style&index=0&id=a57c47f6&prod&lang=scss"
import style1 from "./firstDrops.vue?vue&type=style&index=1&id=a57c47f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57c47f6",
  null
  
)

export default component.exports